import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Form from '@/components/base/form'
import Grid from '@/components/base/grid'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { WPGravityForm } from '@/types'

export type FormSectionProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    title: string
    paragraph: string
    form: WPGravityForm
  }>

const FormSection = ({
  title,
  paragraph,
  form,
  ...props
}: FormSectionProps) => {
  return (
    <Section {...props}>
      <Container>
        <Grid className="gap-y-spacing-lg">
          <div className="col-span-2 md:col-span-3 lg:col-span-6">
            <div className="flex flex-col gap-y-spacing-sm">
              {title ? (
                <Typography
                  variant="h2"
                  component="h1"
                  className="font-medium text-text-accent-light dark:text-text-accent-dark"
                >
                  {title}
                </Typography>
              ) : null}
              {paragraph ? (
                <Typography variant="regular" paragraph>
                  {paragraph}
                </Typography>
              ) : null}
            </div>
          </div>
          <div className="col-span-2 md:col-span-6 lg:col-span-12">
            {form?.id ? (
              <Form
                form_id={form.id}
                fields={form?.fields}
                submit={form?.button?.text}
                theme="light"
              />
            ) : null}
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default FormSection
